// GAPI index
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  state: {
    gapi: {},
  },
  actions,
  mutations,
  getters,
};
